import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><clipPath id=\"i1656868434__a\"><rect width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#i1656868434__a)\"><path fill=\"#202425\" d=\"M0 0h24v24H0V0Z\" style=\"opacity:.009999999776482582;\"></path><path fill=\"#743A3A\" d=\"M4.4 8a7.6 7.6 0 0 1 15.2 0v1.6a7.6 7.6 0 1 1-15.2 0V8ZM12 2.8A5.2 5.2 0 0 0 6.8 8v1.6a5.2 5.2 0 1 0 10.4 0V8A5.2 5.2 0 0 0 12 2.8Z\"></path><path fill=\"#743A3A\" d=\"M2.4 12a3.2 3.2 0 0 1 3.2-3.2h12.8a3.2 3.2 0 0 1 3.2 3.2v8a3.2 3.2 0 0 1-3.2 3.2H5.6A3.2 3.2 0 0 1 2.4 20v-8Z\"></path><path fill=\"#FFF\" d=\"M12 13.2a1.2 1.2 0 0 1 1.2 1.2v3.2a1.2 1.2 0 0 1-2.4 0v-3.2a1.2 1.2 0 0 1 1.2-1.2Z\"></path></g>", 2)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "lock"}) } }